package com.github.jangalinski.tabweb._foundation.size

data object SMALL : SmallToLargeX
